/*
 * component-shared-counter.js — shared Counter-with-text block.
 * Loaded via <script src=… defer> (browser dedupes by URL). IIFE-dedup guard.
 * IntersectionObserver triggers the count-up once per instance; rAF ease-out over
 * data-duration. prefers-reduced-motion -> final value shown immediately (no animation).
 * No-JS users keep the Liquid-rendered final value (SEO-safe). Editor: re-scans on
 * shopify:section:load so newly-added/edited counters animate.
 *
 * Rules: J1 (no inline handlers), J8 (no window.* except the dedup flag), J12 (dedup guard).
 */
(function () {
  if (window.__BLOCKDEDUP_SHARED_COUNTER__) return;
  window.__BLOCKDEDUP_SHARED_COUNTER__ = true;

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(value, decimals, thousands, mark) {
    var fixed = Math.abs(value).toFixed(decimals);
    var parts = fixed.split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var sep = thousands === 'comma' ? ',' : thousands === 'space' ? ' ' : thousands === 'period' ? '.' : '';
    if (sep) intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    var out = (value < 0 ? '-' : '') + intPart;
    if (decimals > 0) out += (mark === 'comma' ? ',' : '.') + decPart;
    return out;
  }

  function read(el) {
    var start = parseFloat(el.getAttribute('data-start')); if (isNaN(start)) start = 0;
    var end = parseFloat(el.getAttribute('data-end')); if (isNaN(end)) end = 0;
    var duration = parseInt(el.getAttribute('data-duration'), 10) || 2000;
    var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
    var thousands = el.getAttribute('data-thousands') || 'none';
    var mark = el.getAttribute('data-decimal-mark') || 'point';
    return { start: start, end: end, duration: duration, decimals: decimals, thousands: thousands, mark: mark };
  }

  function animate(el) {
    var o = read(el);
    var t0 = null;
    function tick(now) {
      if (t0 === null) t0 = now;
      var p = Math.min((now - t0) / o.duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      el.textContent = fmt(o.start + (o.end - o.start) * eased, o.decimals, o.thousands, o.mark);
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = fmt(o.end, o.decimals, o.thousands, o.mark);
    }
    requestAnimationFrame(tick);
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { io.unobserve(e.target); animate(e.target); }
    });
  }, { threshold: 0.4 }) : null;

  function setup(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-counter]:not([data-counter-bound])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-counter-bound', '');
      if (REDUCE) continue; // leave the Liquid-rendered final value; no animation
      var o = read(el);
      el.textContent = fmt(o.start, o.decimals, o.thousands, o.mark); // reset to start so it counts up
      if (io) io.observe(el); else animate(el);
    }
  }

  function init() { setup(document); }
  // PERF-PASS P2.1 FC4 — gate the INITIAL count-up wiring on window load so the
  // rAF timer + textContent reset can't run before load (pre-load timer class).
  // Editor re-scans (shopify:section:load) run post-load and bind immediately.
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init, { once: true });
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
